import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './editorTheme.css';

const TextEditor = ({ value = {score:null, opmerking:'', body:''}, setValue, editorKey }) => {
   // const [value, setValue] = useState({opmerking:''});
  
    const modules = {
      toolbar: [
        [{ 'header': [] }, { 'font': [] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['link'],
        ['clean']                                         
      ],
    };
  
    const formats = [
      'header', 'font', 'list', 'bullet',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'color', 'background', 'align',
      'link'
    ];
  
    const handleChange = (_content, _delta, _source, editor) => {
      const key = editorKey || "opmerking";
      setValue((prev) => ({ ...prev, [key]: editor.getHTML() }));
    };

    const currentValue =
      typeof value === "string"
        ? value
        : value?.[editorKey || "opmerking"] ?? value?.body ?? "";
  
    return (
        <div className="rp-quill mb-5 pt-10" >
        <ReactQuill
          value={currentValue}
          style={{ height: '40vh' }}
          onChange={handleChange}
          modules={modules}
          formats={formats}
        />
        </div>
    );
  };
  
  export default TextEditor;